import React, { PropsWithChildren } from 'react';
import './FormPageBody.scss';

export interface FormPageBodyProps {
  className?: string;
}

export function FormPageBody({ children, className }: PropsWithChildren<FormPageBodyProps>) {
  return <div className={`form-page-body ${className || ''}`}>{children}</div>;
}
